export enum MappingTypes {
  MAPPING_DATA_SUCCESS = 'MAPPING_DATA_SUCCESS',
  MAPPING_DATA_FAILURE = 'MAPPING_DATA_FAILURE',
}

export interface InitialMappingData {
  name: string;
  mappingId: string;
  fieldsToParse: {
    name: string;
    numberCargo: string;
    orderCode: string;
    address: string;
    address2: string;
    weight: string;
    corporateName: string;
    nf: string;
    price: string;
    latitude: string;
    longitude: string;
    cep: string;
    fantasyName?: string;
    weightUnity: string;
  };
}
